module.exports = __webpack_public_path__ + "img/black.baa41458.png";